import { logger } from '@sendpayments/js-utils';

export const reduce = (state, action) => {
  logger.log('@sendpayments/react-shared/remote-data', `reducer/INVALIDATE-ALL. App  invalidating all data`, action);

  const newState = Object.entries(state).reduce((acc, [prop, value]) => {
    acc[prop] = {
      ...value,
      invalidate: true,
    };

    return acc;
  }, {});

  return newState;
};
